<mec-modal
  [options]="modalOptions"
  (closeClick)="closeModal()"
  (negativeClick)="closeModal()"
  (positiveClick)="submitInviteCode()"
  [isSaving]="isSaving"
  [disableActions]="formGroup.invalid"
>
  <form [formGroup]="formGroup" class="field">
    <div [formGroup]="formGroup" class="invite-code-modal field__group">
      <label class="field__label">
        {{ 'INVITE_CODE.DESCRIPTION' | translate }}
      </label>
      <input
        type="text"
        class="field__input"
        formControlName="inviteCode"
        pattern="^(?=(?:.*[0-9]){3})(?=(?:.*[A-Z]){4})[A-Z0-9]{7}$"
        placeholder="{{ 'INVITE_CODE.INPUT_PLACEHOLDER' | translate }}"
      />
      @if(formGroup.get('inviteCode')?.invalid &&
      formGroup.get('inviteCode')?.touched){
      <p class="field__right-label field__right-label--error">
        {{ 'INVITE_CODE.VALIDATION.INVITE_CODE' | translate }}
      </p>
      }
    </div>
  </form>
</mec-modal>
